enum StorageKeys {
    AUTHENTICATED_USER = "AUTHENTICATED_USER",
    THEME_MODE = "THEME_MODE",
    NAV_COLLAPSED = "NAV_COLLAPSED",
    LANGUAGE = "LANGUAGE",
}

export default StorageKeys;